import { render, staticRenderFns } from "./OrderCharts.vue?vue&type=template&id=4c456db0&scoped=true&"
import script from "./OrderCharts.vue?vue&type=script&lang=js&"
export * from "./OrderCharts.vue?vue&type=script&lang=js&"
import style0 from "./OrderCharts.vue?vue&type=style&index=0&id=4c456db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c456db0",
  null
  
)

export default component.exports